import React from 'react';
import type { MoodId } from '../components/crystalMoodData';

// Unicode emoji faces based on the validated Emoji Faces Pain Scale
// (Wong-Baker adapted). U+1F642 → U+1F62D, 6 anchor points across 0-10.
// Kept as a legacy export for ContentEnhancements.tsx (heaviness slider preview).
// Daily check-in sliders now use SCALE_MOOD_IDS via CrystalEmoji.
export const SCALE_EMOJIS: Record<number, React.ReactNode> = {
  0: '🙂', 1: '🙂',
  2: '😐', 3: '😐',
  4: '🙁', 5: '🙁',
  6: '☹️', 7: '☹️',
  8: '😩', 9: '😩',
  10: '😭',
};

// Inverted scale for "feeling" sliders where 0 = worst, 10 = best
export const MOOD_EMOJIS: Record<number, React.ReactNode> = {
  0: '😭', 1: '😩',
  2: '😩', 3: '☹️',
  4: '☹️', 5: '🙁',
  6: '🙁', 7: '😐',
  8: '😐', 9: '🙂',
  10: '🙂',
};

// Wong-Baker FACES pain-rating scale mapped to bond-2 Citrine moods.
// Distress increases with number; same six anchor points as SCALE_EMOJIS.
// 0/1   = happy   (no hurt, big smile)
// 2/3   = okay    (hurts a little bit, neutral)
// 4/5   = worried (hurts a little more, anxious)
// 6/7   = tired   (hurts even more, slumped + tiny-flat mouth)
// 8/9   = hurting (hurts a whole lot, flat mouth + grey tint)
// 10    = flaring (hurts worst, grimace + crisis-level tint)
export const SCALE_MOOD_IDS: Record<number, MoodId> = {
  0: 'happy',   1: 'happy',
  2: 'okay',    3: 'okay',
  4: 'worried', 5: 'worried',
  6: 'tired',   7: 'tired',
  8: 'hurting', 9: 'hurting',
  10: 'flaring',
};

export type PainIntensity = 1 | 2 | 3;

// Body-map pain intensity colouring. Uses the graduated-amethyst risk tier
// (see --color-risk-*-fill in index.css) rather than amber/orange/red traffic-light
// coding — same Crisis Plan stigma rationale: "being in the red" on your own body
// map carries an alarm/judgement affect that the amethyst tier avoids while still
// reading as a clear severity gradient.
export const INTENSITY_COLORS: Record<PainIntensity, string> = {
  1: 'var(--color-risk-low-fill)',
  2: 'var(--color-risk-moderate-fill)',
  3: 'var(--color-risk-high-fill)',
};

export const INTENSITY_LABELS: Record<PainIntensity, string> = {
  1: 'mild',
  2: 'moderate',
  3: 'severe',
};
